import { useEffect } from 'react'

import { useQuantRuns } from '@/app/hooks/useQuantRuns'
import { observeRun } from '@/app/lib/quant/runFinish'
import { useSignalLog } from '@/app/lib/signalLog'

/**
 * Mounted once by QuantShell so a run that finishes while the operator is on
 * Manual trade or Jupyter still writes its one Signal line (spec 036 T7.2).
 */
export function useQuantRunFinishLogs(): void {
  const state = useQuantRuns()
  const { emit } = useSignalLog()
  const runs = state.status === 'loaded' ? state.runs : null
  useEffect(() => {
    if (runs === null) return
    for (const run of runs) observeRun(run, emit)
  }, [runs, emit])
}
